import { SFormUploadImage } from 'shj-components'
import ImageUpload from '@/components/Upload/ImageUpload'
import { baseURL } from '@/api'
import { message, Upload } from 'antd'

const UPLOAD_IMAGE_LIMIT_NUMBER = 20 // 上传图片限制数量
const UPLOAD_IMAGE_ACCEPT = '.jpg,.jpeg,.png' // 上传图片类型
const UPLOAD_URL = baseURL + 'file-web/file/upload' // 上传图片地址
const UPLOAD_FILE_ACCEPT = '.dwg,.dxf,.dwt,.cdr,.skp,.max,.3ds,.mb,.ma' // 上传文件类型

const DrawingManagementConfig = (props: { status: string, updateMap: any }) => {
  const { status, updateMap = {} } = props

  // 自定义预览方式
  const handlePreview = file => window.open(file.response?.data?.fileUrl || file.url)

  // 上传图片大小不能超过10MB
  const beforeUploadImg = (image: any) => {
    const isLt10M = image.size / 1024 / 1024 < 10
    console.log(isLt10M)
    if (!isLt10M) {
      message.error('图片大小限制10MB!')
      return Upload.LIST_IGNORE // 阻止列表展现
    }
    return true
  }

  // 上传图片统一属性
  const imageUploadAttr = {
    url: UPLOAD_URL,
    accept: UPLOAD_IMAGE_ACCEPT,
    limit: UPLOAD_IMAGE_LIMIT_NUMBER,
    disabled: true,
    beforeUpload: beforeUploadImg,
    handlePreview,
  }

  return [
    {
      title: <div id="drawing-desc">图纸说明</div>,
      formItem: [
        {
          name: 'drawDesc-Catalogue',
          label: <div style={{ color: updateMap?.['drawDesc-Catalogue'] ? 'red' : 'black' }} id="drawDesc-Catalogue">图纸目录</div>,
          required: true,
          rules: [{ required: true, message: '图纸目录必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'drawDesc-designDesc',
          label: <div style={{ color: updateMap?.['drawDesc-designDesc'] ? 'red' : 'black' }} id="drawDesc-designDesc">设计说明</div>,
          required: true,
          rules: [{ required: true, message: '设计说明必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'drawDesc-drawDemlist',
          label: <div style={{ color: updateMap?.['drawDesc-drawDemlist'] ? 'red' : 'black' }} id="drawDesc-drawDemlist">图例表</div>,
          required: true,
          rules: [{ required: true, message: '图例表必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'drawDesc-desc',
          label: <div style={{ color: updateMap?.['drawDesc-desc'] ? 'red' : 'black' }} id="drawDesc-desc">现场交底特殊情况说明</div>,
          required: true,
          rules: [{ required: true, message: '现场交底特殊情况说明必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'drawDesc-desc1',
          label: <div style={{ color: updateMap?.['drawDesc-desc1'] ? 'red' : 'black' }} id="drawDesc-desc1">常用家电尺寸规格建议</div>,
          required: true,
          rules: [{ required: true, message: '常用家电尺寸规格建议必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
      ],
    },
    {
      title: <div id="drawing-origin">原始类施工图</div>,
      formItem: [
        {
          name: 'origin-OriginalStructure',
          label: <div style={{ color: updateMap?.['origin-OriginalStructure'] ? 'red' : 'black' }} id="origin-OriginalStructure">原始结构图</div>,
          required: true,
          rules: [{ required: true, message: '原始结构图必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'origin-OriginalTop',
          label: <div style={{ color: updateMap?.['origin-OriginalTop'] ? 'red' : 'black' }} id="origin-OriginalTop">原始顶面图</div>,
          required: true,
          rules: [{ required: true, message: '原始顶面图必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'origin-OriginalPeri',
          label: <div style={{ color: updateMap?.['origin-OriginalPeri'] ? 'red' : 'black' }} id="origin-OriginalPeri">原始面积周长图</div>,
          required: true,
          rules: [{ required: true, message: '原始面积周长图必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
      ],
    },
    {
      title: <div id="drawing-demolition">拆改类施工图</div>,
      formItem: [
        {
          name: 'unknit-WallDemolition',
          label: <div style={{ color: updateMap?.['unknit-WallDemolition'] ? 'red' : 'black' }} id="unknit-WallDemolition">墙体拆除图</div>,
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'unknit-WallNew',
          label: <div style={{ color: updateMap?.['unknit-WallNew'] ? 'red' : 'black' }} id="unknit-WallNew">墙体新建图</div>,
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'unknit-ReconstructionArea',
          label: <div style={{ color: updateMap?.['unknit-ReconstructionArea'] ? 'red' : 'black' }} id="unknit-ReconstructionArea">改造后面积周长图</div>,
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'unknit-OriginalConstruction',
          label: <div style={{ color: updateMap?.['unknit-OriginalConstruction'] ? 'red' : 'black' }} id="unknit-OriginalConstruction">原始地面施工图</div>,
          required: true,
          rules: [{ required: true, message: '原始地面施工图必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
      ],
    },
    {
      title: <div id="drawing-ground">地面类施工图</div>,
      formItem: [
        {
          name: 'ground-PlaneLayout',
          label: <div style={{ color: updateMap?.['ground-PlaneLayout'] ? 'red' : 'black' }} id="ground-PlaneLayout">平面布置图</div>,
          required: true,
          rules: [{ required: true, message: '平面布置图必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'ground-HomeMain',
          label: <div style={{ color: updateMap?.['ground-HomeMain'] ? 'red' : 'black' }} id="ground-HomeMain">家具主材尺寸图</div>,
          required: true,
          rules: [{ required: true, message: '家具主材尺寸图必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'ground-FloorCovering',
          label: <div style={{ color: updateMap?.['ground-FloorCovering'] ? 'red' : 'black' }} id="ground-FloorCovering">地面铺装图</div>,
          required: true,
          rules: [{ required: true, message: '地面铺装图必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
      ],
    },
    {
      title: <div id="drawing-ceiling">顶面类施工图</div>,
      formItem: [
        {
          name: 'top-topModelling',
          label: <div style={{ color: updateMap?.['top-topModelling'] ? 'red' : 'black' }} id="top-topModelling">顶面造型图</div>,
          required: true,
          rules: [{ required: true, message: '顶面造型图必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'top-topSize',
          label: <div style={{ color: updateMap?.['top-topSize'] ? 'red' : 'black' }} id="top-topSize">顶面造型尺寸图</div>,
          required: true,
          rules: [{ required: true, message: '顶面造型尺寸图必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
      ],
    },
    {
      title: <div id="drawing-electricity">水电类施工图</div>,
      formItem: [
        {
          name: 'waterElectric-waterStrong',
          label: <div style={{ color: updateMap?.['waterElectric-waterStrong'] ? 'red' : 'black' }} id="waterElectric-waterStrong">水电包标配强电点位图</div>,
          required: true,
          rules: [{ required: true, message: '水电包标配强电点位图必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'waterElectric-waterWeak',
          label: <div style={{ color: updateMap?.['waterElectric-waterWeak'] ? 'red' : 'black' }} id="waterElectric-waterWeak">水电包标配强弱电点位图</div>,
          required: true,
          rules: [{ required: true, message: '水电包标配强弱电点位图必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'waterElectric-waterSwitch',
          label: <div style={{ color: updateMap?.['waterElectric-waterSwitch'] ? 'red' : 'black' }}  id="waterElectric-waterSwitch">开关布置图</div>,
          required: true,
          rules: [{ required: true, message: '开关布置图必须上传图片' }],
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
      ],
    },
    {
      title: <div id="drawing-elevation">立面类施工图</div>,
      formItem: [
        {
          name: 'facade-restaurant',
          label: <div style={{ color: updateMap?.['facade-restaurant'] ? 'red' : 'black' }} id="facade-restaurant">客餐厅立面图</div>,
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'facade-kitchen',
          label: <div style={{ color: updateMap?.['facade-kitchen'] ? 'red' : 'black' }} id="facade-kitchen">厨房展开立面图</div>,
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'facade-TOILET',
          label: <div style={{ color: updateMap?.['facade-kitchen'] ? 'red' : 'TOILET' }} id="facade-TOILET">卫生间展开立面图</div>,
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'facade-bedroom',
          label: <div style={{ color: updateMap?.['facade-bedroom'] ? 'red' : 'TOILET' }} id="facade-bedroom">卧室立面图</div>,
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
      ],
    },
    {
      title: <div id="drawing-other">其他类施工图</div>,
      formItem: [
        {
          name: 'other-disclose',
          label: <div style={{ color: updateMap?.['other-disclose'] ? 'red' : 'TOILET' }} id="other-disclose">开工交底单</div>,
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'other-node',
          label: <div style={{ color: updateMap?.['other-node'] ? 'red' : 'TOILET' }} id="other-node">节点大样图</div>,
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
        {
          name: 'other-staticState',
          label: <div style={{ color: updateMap?.['other-staticState'] ? 'red' : 'TOILET' }} id="other-staticState">静态效果图</div>,
          children: <SFormUploadImage {...imageUploadAttr} />,
          spanCol: 24,
        },
      ],
    },
    {
      title: <div id="drawing-source">源文件</div>,
      formItem: [
        {
          name: 'source-sourceFile',
          label: <div style={{ color: updateMap?.['source-sourceFile'] ? 'red' : 'TOILET' }} id="source-sourceFile">源文件</div>,
          required: true,
          rules: [{ required: true, message: '源文件必须上传图片' }],
          children: (
            <ImageUpload
              processDisabled={true}
              readonly={true}
              listType="text"
              acceptType={UPLOAD_FILE_ACCEPT}
              limit={UPLOAD_IMAGE_LIMIT_NUMBER}
            />
          ),
          spanCol: 12,
        },
      ],
    },
  ]
}

export default DrawingManagementConfig
